import {font_s_md, font_s_sm, btn_li, btn_md, btn_sm, btn_xs, btn_c_link, svg_md, btn_c_lightRed, shadow_box_md, clearfix, colors} from '@xpertdox_js/xdstyle';

export default {
  clearfix,
  labTitle: {
    margin: '12px auto 2px',
    ...font_s_md,
  },
  labFormContainer: {
    ...clearfix,
    float: 'left',
    width: '90%',
  },
  labLabel: {
    width: '50%',
    float: 'left',
  },
  labSubTitle: {
    ...font_s_sm,
    margin: '0 auto 4px'
  },
  removeBtn: {
    float: 'left',
    width: '10%',
    marginTop: '2px',
    ...btn_sm,
    ...btn_c_lightRed.base,
    borderRadius: '4px',
  },
  removeBtnHov: {
    ...btn_c_lightRed.hover,
  },
  removeIcon: {
    ...svg_md,
    margin: '.1rem auto',
  },
}
